/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import { Mobile, PC } from 'components/common/Responsive';
import TitleImg from 'static/intro/title.png';
import TitleImgM from 'static/intro/title_m.png';

const Title = () => {
  const { mq } = useTheme();
  const titleStyle = css`
    height: 714px;
    display: flex;
    padding-top: 78px;
    align-items: center;
    justify-content: center;
    background-image: url(${TitleImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    color: #fff;
    .title {
      text-align: center;
      h2 {
        font-size: 56px;
        font-weight: 600;
        line-height: 76px;
      }
      .text {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 5px;
      }
    }
    ${mq.mobile} {
      height: 640px;
      padding-top: 48px;
      background-image: url(${TitleImgM});
      .title {
        h2 {
          font-size: 30px;
          line-height: 40px;
        }
        .text {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  `;

  return (
    <div css={titleStyle}>
      <div className="title">
        <h2>몰파이 플랫폼 소개</h2>
        <div className="text">
          누구나 쉽게 나의 취향대로 쇼핑몰을 생성하고, 꾸준한 수익으로
          <Mobile>
            <br />
          </Mobile>
          즐거운 경험을 느낄 수 있으며,
          <PC>
            <br />
          </PC>
          입점사는 몰파이의 다채널 상품 광고로
          <Mobile>
            <br />
          </Mobile>
          매출 확대의 기회를 높일 수 있습니다.
        </div>
      </div>
    </div>
  );
};

export default Title;
